// public/js/router.js

export function initRouter(pages) {
  console.log('🚀 Router initialised');

  const content = document.getElementById('main-content');
  const mapWrapper = document.getElementById('map-wrapper');

  function isMapHash(key) {
    return key === '#map';
  }

  async function loadPage(hash) {
    // Sub-paths like "#assets/<uuid>" resolve to their base page ("#assets");
    // the page itself reads the full hash to open the right detail view.
    const pageKey = (hash || '#map').split('/')[0];

    // Cleanup the map page when leaving it
    if (!isMapHash(pageKey)) {
      try {
        const mapModule = await import('./modules/map.js');
        mapModule.clearAllMapData?.();
        const pageModule = await import('./pages/map.js');
        pageModule.hideMapFilters?.();
      } catch (e) {}
    }

    console.log(`[ROUTER] Loading page: ${pageKey}`);

    const pageFn = pages[pageKey] || pages['#map'];

    if (pageKey === '#map') {
      // MapLibre map page
      content.classList.add('d-none');
      if (mapWrapper) mapWrapper.classList.remove('d-none');
      window.showSpinner?.('Loading map...');
      try {
        await pageFn();
        // Ensure the MapLibre canvas has correct size after becoming visible
        try {
          const mapMod = await import('./modules/map.js');
          const m = mapMod.getMapInstance?.();
          if (m && typeof m.resize === 'function') {
            setTimeout(() => { try { m.resize(); } catch (e) {} }, 120);
          }
        } catch (e) {}
        console.log('✅ Map (MapLibre) activated');
      } finally {
        window.hideSpinner?.();
      }
    } else {
      // Regular pages
      if (mapWrapper) mapWrapper.classList.add('d-none');
      content.classList.remove('d-none');
      content.innerHTML = '';
      window.showSpinner?.('Loading...');
      try {
        await pageFn(content);
        console.log(`✅ ${pageKey} page loaded`);
      } finally {
        window.hideSpinner?.();
      }
    }
  }

  window.addEventListener('hashchange', () => loadPage(window.location.hash));
  loadPage(window.location.hash);
}
